// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"891":"3fc4c69c","949":"b10e115f"}[chunkId] + ".chunk.js";
};